var _rect, _text, _g, _path, _rect2, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg107(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uB05D\uC218\uC911\uBCF5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#eef7f5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 75,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 900,
    fill: "#172033"
  }, "\uB9C8\uC9C0\uB9C9 \uC790\uB9AC\uAC00 \uAC19\uC740 \uC22B\uC790 \uBB36\uAE30")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 210,
    r: 62,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 223
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 210,
    r: 62,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 223
  }, "13"), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 210,
    r: 62,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 223
  }, "23"), /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 210,
    r: 62,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 645,
    y: 223
  }, "43"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 298v30h495v-30M315 298v30M480 298v30",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 330,
    width: 230,
    height: 64,
    rx: 32,
    fill: "#0f766e"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 372,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 29,
    fontWeight: 900,
    fill: "#fff"
  }, "\uB05D\uC218 3 \uADF8\uB8F9")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg107);
export default __webpack_public_path__ + "static/media/107-끝수중복.48564304748f081ccd17550a2bd1818c.svg";
export { ForwardRef as ReactComponent };